import moment from 'moment';

/**
 * Formats a date string with time
 * @param dateString - The date string to format
 * @returns Formatted date string with time
 */
export const formatDateWithTime = (dateString: string): string => {
  if (!dateString) {
    return '-';
  }

  const momentDate = moment(dateString);

  if (!momentDate.isValid()) {
    return '-';
  }

  return momentDate.format('MMM DD, YYYY HH:mm:ss');
};

/**
 * Formats a date string without time
 * @param dateString - The date string to format
 * @returns Formatted date string without time
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) {
    return '-';
  }

  const momentDate = moment(dateString);

  if (!momentDate.isValid()) {
    return '-';
  }

  return momentDate.format('MMM DD, YYYY');
};
